import "./node_modules/bootstrap/dist/css/bootstrap.css";
